enum SolicitacaoOrderByEnum {
  default = '',
  dataStatusAlterado = 'dataStatusAlterado',
  dataAgendamento = 'dataAgendamento',
}

export default SolicitacaoOrderByEnum
